import { Component, input } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxSectionComponent,
  OnyxTextareaComponent,
  onyxTextareaLengthValidator,
} from '@onyx/angular';

type NoteFormGroup = ReturnType<(typeof NoteFormComponent)['buildForm']>;

@Component({
  selector: 'app-note-form',
  imports: [
    OnyxSectionComponent,
    TranslatePipe,
    ReactiveFormsModule,
    OnyxTextareaComponent,
  ],
  templateUrl: './note-form.component.html',
  styleUrl: './note-form.component.scss',
})
export class NoteFormComponent {
  public readonly form = input.required<NoteFormGroup>();
  public readonly placeholder = input.required<string>();
  public readonly minResizeHeight = input<`${string}px`>('120px');

  public static buildForm(fb: NonNullableFormBuilder) {
    return fb.group({
      content: fb.control<string | null>(null, [onyxTextareaLengthValidator]),
    });
  }
}
